import cn from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Skeleton } from "antd";

//
const InvitationHistory = () => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const [invitationData, setInvitationData] = useState({
    loading: false,
    data: [],
  });

  const getInvitationHistory = useCallback(async () => {
    setInvitationData({
      loading: true,
      data: [],
    });
    const data = await fetch(
      `${process.env.REACT_APP_RIDER_API}/point-history/share-history?page=0&limit=20`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => data)
      .catch((err) => console.error("Shop:", err));
    setInvitationData({
      loading: false,
      data: data?.shareHistoryResponse || [],
    });
  }, []);

  useEffect(() => {
    getInvitationHistory();
  }, [getInvitationHistory]);

  return (
    <div className="block">
      <div className={cn(`border rounded-xl bg-white min-h-full`)}>
        <div
          className={cn(
            `w-full text-center rounded-t-xl bg-gray-200 border-b-2`
          )}
          style={{ background: "#F4ECCE", borderColor: "#F4ECCE" }}
        >
          <div
            className="border-b p-4 py-6 flex gap-3 place-content-center items-start"
            style={{ borderColor: "#EAA92A" }}
          >
            <span
              className={cn(`text-gray-600 text-xl lg:text-2xl font-extrabold`)}
            >
              My Invitation History
            </span>
          </div>

          <div className="w-full p-4 grid grid-cols-3 justify-items-stretch gap-2 text-md text-lg font-bold capitalize px-2 lg:px-8">
            <span className="text-left">User Name</span>
            <span>Active Point's</span>
            <span>Inactive Point's</span>
          </div>
        </div>
        <div className={cn(`w-full rounded-xl`)}>
          {invitationData?.loading ? (
            <div className="grid grid-cols-1 gap-1">
              <Skeleton>
                <div className="w-full h-12" />
              </Skeleton>
            </div>
          ) : invitationData?.data?.length ? (
            invitationData?.data?.map((point: any, i) => (
              <>
                <div
                  className="w-full grid grid-cols-3 justify-items-stretch gap-2 text-md py-3 border-t capitalize px-2 lg:px-8"
                  key={i}
                >
                  <span>{point?.userName}</span>
                  <span className="text-center">{point?.activePoints}</span>
                  <span className="text-center">{point?.inActivePoints}</span>
                </div>
              </>
            ))
          ) : (
            <span className="p-4 block text-red-600 text-center">
              No data found
            </span>
          )}
        </div>
      </div>{" "}
    </div>
  );
};

export default InvitationHistory;
